<template>
    <div class="proposals h-100">
        <v-container fluid class="h-100 d-flex flex-column">
            <v-row class="h-100 flex-grow-1">
                <v-col cols="12" md="5">
                    <v-card class="d-flex flex-column">
                        <v-card-title style="flex: 0 1 auto;">
                            <span>Business Proposals</span>
                            <v-spacer></v-spacer>
                            <v-btn color="secondary" outlined @click="loadBusinessProposals()"><v-icon>refresh</v-icon>Refresh</v-btn>
                        </v-card-title>
                        <v-data-table
                            fixed-header
                            hide-default-footer
                            :headers="businessProposalsHeaders"
                            height="37vh"
                            :items-per-page="100"
                            :items="businessProposals"
                            style="flex: 1 1 auto;"
                        >
                            <template v-slot:item="props">
                                <tr>
                                    <td class="text-xs-left">
                                        {{ props.item.id }}
                                    </td>
                                    <td class="text-xs-left">
                                        <strong>{{ props.item.name }}</strong>
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.city }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.created_at | formatDateTimeMinutes }}
                                    </td>
                                    <td class="text-xs-left">
                                        <span v-if="props.item.user">
                                            <router-link :to="{ name: 'users.details', params: { id: props.item.user } }" target="_blank">
                                                {{ props.item.user }}
                                            </router-link>
                                        </span>
                                        <span v-else>-</span>
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.business_added }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
                <v-col cols="12" md="7">
                    <v-card class="d-flex flex-column">
                        <v-card-title style="flex: 0 1 auto;">
                            <span>Staff Business Proposals</span>
                            <v-spacer></v-spacer>
                            <v-btn color="secondary" outlined @click="loadStaffBusinessProposals()"><v-icon>refresh</v-icon>Refresh</v-btn>
                        </v-card-title>
                        <v-data-table
                            fixed-header
                            hide-default-footer
                            :headers="staffBusinessProposalsHeaders"
                            height="37vh"
                            :items-per-page="100"
                            :items="staffBusinessProposals"
                            style="flex: 1 1 auto;"
                        >
                            <template v-slot:item="props">
                                <tr>
                                    <td class="text-xs-left">
                                        {{ props.item.id }}
                                    </td>
                                    <td class="text-xs-left">
                                        <strong>{{ props.item.name }}</strong>
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.city }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.phone }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.email }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.owner_full_name }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.created_at | formatDateTimeMinutes }}
                                    </td>
                                    <td class="text-xs-left">
                                        <span v-if="props.item.user">
                                            <router-link :to="{ name: 'users.details', params: { id: props.item.user } }" target="_blank">
                                                {{ props.item.user }}
                                            </router-link>
                                        </span>
                                        <span v-else>-</span>
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.business_added }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
            <v-row class="h-100 flex-grow-1">
                <v-col cols="12">
                    <v-card class="d-flex flex-column">
                        <v-card-title style="flex: 0 1 auto;">
                            <span>Service Proposals</span>
                            <v-spacer></v-spacer>
                            <v-btn color="secondary" outlined @click="loadServiceProposals()"><v-icon>refresh</v-icon>Refresh</v-btn>
                        </v-card-title>
                        <v-data-table
                            fixed-header
                            hide-default-footer
                            :headers="serviceProposalsHeaders"
                            height="37vh"
                            :items-per-page="100"
                            :items="serviceProposals"
                            style="flex: 1 1 auto;"
                        >
                            <template v-slot:item="props">
                                <tr>
                                    <td class="text-xs-left">
                                        {{ props.item.id }}
                                    </td>
                                    <td class="text-xs-left">
                                        <strong>{{ props.item.name }}</strong>
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.city }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.phone }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.email }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.owner_full_name }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.service }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.service_proposal_status }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.created_at | formatDateTimeMinutes }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.desription }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { ProposalsApi } from '@/api';
import { dates } from '@/utils/mixins';

export default {
    name: 'Proposals',
    mixins: [dates],
    data: () => ({
        businessProposals: [],
        staffBusinessProposals: [],
        serviceProposals: [],
        businessProposalsHeaders: [
            {
                text: 'ID',
                align: 'left',
                sortable: false,
                width: '10%',
            },
            {
                text: 'Name',
                align: 'left',
                sortable: true,
                width: '20%',
            },
            {
                text: 'City',
                align: 'left',
                sortable: false,
                width: '20%',
            },
            {
                text: 'Created At',
                align: 'left',
                sortable: false,
                width: '20%',
            },
            {
                text: 'User',
                align: 'left',
                sortable: false,
                width: '15%',
            },
            {
                text: 'Added',
                align: 'left',
                sortable: false,
                width: '15%',
            },
        ],
        staffBusinessProposalsHeaders: [
            {
                text: 'ID',
                align: 'left',
                sortable: false,
                width: '5%',
            },
            {
                text: 'Name',
                align: 'left',
                sortable: true,
                width: '18%',
            },
            {
                text: 'City',
                align: 'left',
                sortable: false,
                width: '15%',
            },
            {
                text: 'Phone',
                align: 'left',
                sortable: false,
                width: '12%',
            },
            {
                text: 'Email',
                align: 'left',
                sortable: false,
                width: '15%',
            },
            {
                text: 'Owner',
                align: 'left',
                sortable: false,
                width: '15%',
            },
            {
                text: 'Created At',
                align: 'left',
                sortable: false,
                width: '10%',
            },
            {
                text: 'User',
                align: 'left',
                sortable: false,
                width: '5%',
            },
            {
                text: 'Added',
                align: 'left',
                sortable: false,
                width: '5%',
            },
        ],
        serviceProposalsHeaders: [
            {
                text: 'ID',
                align: 'left',
                sortable: false,
                width: '5%',
            },
            {
                text: 'Name',
                align: 'left',
                sortable: true,
                width: '10%',
            },
            {
                text: 'City',
                align: 'left',
                sortable: false,
                width: '10%',
            },
            {
                text: 'Phone',
                align: 'left',
                sortable: false,
                width: '10%',
            },
            {
                text: 'Email',
                align: 'left',
                sortable: false,
                width: '10%',
            },
            {
                text: 'Owner',
                align: 'left',
                sortable: false,
                width: '10%',
            },
            {
                text: 'Service',
                align: 'left',
                sortable: false,
                width: '10%',
            },
            {
                text: 'Proposal Status',
                align: 'left',
                sortable: false,
                width: '10%',
            },
            {
                text: 'Created At',
                align: 'left',
                sortable: false,
                width: '10%',
            },
            {
                text: 'Description',
                align: 'left',
                sortable: false,
                width: '15%',
            },
        ],
    }),
    created() {
        this.loadBusinessProposals();
        this.loadStaffBusinessProposals();
        this.loadServiceProposals();
    },
    methods: {
        async loadBusinessProposals() {
            const { data: items } = await ProposalsApi.businessProposals();
            this.businessProposals = items;
        },
        async loadStaffBusinessProposals() {
            const { data: items } = await ProposalsApi.staffBusinessProposals();
            this.staffBusinessProposals = items;
        },
        async loadServiceProposals() {
            const { data: items } = await ProposalsApi.serviceProposals();
            this.serviceProposals = items;
        },
    },
};
</script>

<style lang="scss"></style>
